
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { ReferenceDataType } from "@/store/referenceData/types";
import { getReferenceDataDescription } from "@/helpers/referenceData";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    NZBNANZSICCode() {
      const applicationData = store.state.application.applicationData;
      const business =
        applicationData &&
        applicationData.businessDetails &&
        applicationData.businessDetails.business;

      const industryClassification: any =
        business && Array.isArray(business.industryClassification)
          ? business.industryClassification
          : [];

      return industryClassification
        .map((i: any) => {
          // AO-164: ANZSIC code: the four digit number which are characters 2 - 5 of
          // the business industry code. E.g. if the business industry code (aka BIC code)
          // is G412940 then the ANZSIC code is 4129
          return typeof i.classificationCode === "string"
            ? i.classificationCode.substr(1, 4)
            : "";
        })
        .join(",");
    },
    classOfBuyer() {
      const promoClassOfBuyerType =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.classOfBuyer;

      const standardOfferClassOfBuyerType =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.classOfBuyer;

      const classOfBuyerType =
        promoClassOfBuyerType || standardOfferClassOfBuyerType;

      return getReferenceDataDescription(
        classOfBuyerType,
        ReferenceDataType.ClassOfBuyer
      );
    },
    collectionManager() {
      const promoCollectionManagerType =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.collectionManager;

      const standardCollectionManagerType =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.collectionManager;

      const collectionManagerType =
        promoCollectionManagerType || standardCollectionManagerType;

      return getReferenceDataDescription(
        collectionManagerType,
        ReferenceDataType.CollectionManager
      );
    },
    salesRepresentative() {
      const promoSalesRepresentativeType =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.salesRepresentative;

      const standardSalesRepresentativeType =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.salesRepresentative;

      const salesRepresentativeType =
        promoSalesRepresentativeType || standardSalesRepresentativeType;

      return getReferenceDataDescription(
        salesRepresentativeType,
        ReferenceDataType.SalesRepresentative
      );
    },
    businessType(): string {
      const businessType =
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.businessType;

      return businessType || this.NZBNEntityType;
    },
    NZBNEntityType(): any {
      return (
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.business &&
        store.state.application.applicationData.businessDetails.business
          .entityTypeCode
      );
    }
  },
  methods: {},
  validations: {}
});
